'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { useNavigationHistoryStore } from '~/stores/navigationHistoryStore';

export const useNavigationHistory = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const push = useNavigationHistoryStore((s) => s.push);

  useEffect(() => {
    const search = searchParams.toString();
    push(search ? `${pathname}?${search}` : pathname);
  }, [pathname, searchParams, push]);
};
